module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-licensing-1b5b2e29ee35023231e2cac4d27492cc.svg";